/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Project',dictionary:{"de":{"references":{"type":"Art","category":"Kategorie","customer":"Kunde","projectContacts":"Kontakte","status":"Status"},"general":{"name":"Name","description":"Beschreibung"},"projectId":"Projekt-ID","__getters":{"localAddress":"Adresse","internationalAddress":"Adresse","projectCustomer":"Kunde","projectNameAddress":"Projekt","responsibleWorkersString":"Projektbetreuer"},"address":{"street":"Straße und Nummer","zipCode":"PLZ","city":"Ort","country":"Land","__getters":{"localAddress":"Adresse","interationalAddress":"Adresse"}},"geoLocation":{"latitude":"Längengrad","longitude":"Breitengrad"},"start":"Start","end":"Ende"},"en":{"references":{"type":"Type","category":"Category","customer":"Customer","responsibleCustomerPerson":"Responsible Customer Person","status":"Status"},"general":{"name":"Name","description":"Description"},"projectId":"Project-ID","__getters":{"localAddress":"Address","internationalAddress":"Address","projectCustomer":"Customer","projectNameAddress":"Project","responsibleWorkersString":"Projektbetreuer"},"address":{"street":"Street and Number","zipCode":"Zip-Code","city":"City","country":"Country","__getters":{"localAddress":"Address","interationalAddress":"Address"}},"geoLocation":{"latitude":"Latitude","longitude":"Longitude"},"start":"Start","end":"End"}}})
import { Login } from './Login';
import { ProjectType } from './ProjectType';
import { ProjectCategory } from './ProjectCategory';
import { Customer } from './Customer';
import { Person } from './Person';
import { Worker } from './Worker';
import { ProjectStatus } from './ProjectStatus';
import { WorkRecord } from './WorkRecord';
import { ProjectTimeReport } from './ProjectTimeReport';
import _ from 'lodash';

export class Project extends _BaseModel {
	
	static toString() {
		return 'Project'
	}
	
	get __getters() {
		const self = this;
		return {
			get localAddress() {
        return (self.address.street ? self.address.street + ', ' : '') + (self.address.zipCode ? self.address.zipCode + '-' : '') + self.address.city;
    },
			get internationalAddress() {
        return (
            (self.address.street ? self.address.street + ', ' : '') +
            (self.address.zipCode ? self.address.zipCode + '-' : '') +
            (self.address.city ? self.address.city + ', ' : '') +
            self.address.country
        );
    },
			get projectNameAddress() {
        const nameString = _.get(self.general, 'name', '');
        const ref = self;
        let addressString = '';

        if (_.get(ref, 'address.street')) addressString += ', ' + ref.address.street;
        if (_.get(ref, 'address.zipCode')) addressString += ', ' + ref.address.zipCode;
        if (_.get(ref, 'address.city')) addressString += ' - ' + ref.address.city;
        if (_.get(ref, 'address.country')) addressString += ', ' + ref.address.country;

        return nameString + addressString;
    },
			get projectIdNameAddress() {
        const ref = self.address;
        let addressString = '';

        if (_.get(ref, 'address.street')) addressString += ', ' + ref.address.street;
        if (_.get(ref, 'address.zipCode')) addressString += ', ' + ref.address.zipCode;
        if (_.get(ref, 'address.city')) addressString += ' - ' + ref.address.city;
        if (_.get(ref, 'address.country')) addressString += ', ' + ref.address.country;

        let nameString = '';
        if (_.get(self.general, 'name')) nameString += ' - ' + self.general.name;

        return self.projectId + nameString + addressString;
    },
			get projectCustomer() {
        const customerString = _.get(self.references, 'customer.__getters.customerIdName');
        return customerString;
    },
			get responsibleWorkersString() {
        const workerArray = _.get(self.references, 'responsibleWorkers', []);

        return workerArray
            .map(function (item) {
                return _.get(item, 'references.person.__getters.lastFirstTitleName');
            })
            .sort()
            .join(', ');
    },
		}
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Project.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Project', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Project.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Project', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Project.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Project', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Project', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Project', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Project.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Project', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Project'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Project) || _BaseModel.t('rules.reference', {modelName:'Project', path:'meta.currentDocument'}) ],
				model: Project,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Project', path:'meta.revisions'}) ],
				model: Project,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	type:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectType'),
				itemText: "general.name",
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ProjectType) || _BaseModel.t('rules.reference', {modelName:'Project', path:'references.type'}) ],
				model: ProjectType,
				returnObject: true,
},
    
	},
	
					
	category:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectCategory'),
				itemText: "general.name",
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ProjectCategory) || _BaseModel.t('rules.reference', {modelName:'Project', path:'references.category'}) ],
				model: ProjectCategory,
				returnObject: true,
},
    
	},
	
					
	customer:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Customer'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Customer) || _BaseModel.t('rules.reference', {modelName:'Project', path:'references.customer'}) ],
				model: Customer,
				returnObject: true,
},
    
	},
	
					
	projectContacts:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Person'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Project', path:'references.projectContacts'}) ],
				model: Person,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	responsibleWorkers:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Project', path:'references.responsibleWorkers'}) ],
				model: Worker,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	status:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectStatus'),
				itemText: "general.name",
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ProjectStatus) || _BaseModel.t('rules.reference', {modelName:'Project', path:'references.status'}) ],
				model: ProjectStatus,
				returnObject: true,
},
    
	},
	
					
	workRecords:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkRecord'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Project', path:'references.workRecords'}) ],
				model: WorkRecord,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	projectTimeReports:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectTimeReport'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Project', path:'references.projectTimeReports'}) ],
				model: ProjectTimeReport,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			general: 				{
					
	name:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Project.general.name'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Project', path:'general.name'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Project', path:'general.name'}) ],
},
    
	},
	
					
	description:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.Project.general.description'),
				rows: 1,
				autoGrow: true,
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Project', path:'general.description'}) ],
},
    
	},
	
},
				
	projectId:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Project.projectId'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Project', path:'projectId'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Project', path:'projectId'}) ],
},
    
	},
	
			geoLocation: 				{
					
	latitude:{
		type: 'number',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Project.geoLocation.latitude'),
				rules: [ (value)=> (value === undefined || value === null || typeof +value === 'number') || _BaseModel.t('rules.type.number', {modelName:'Project', path:'geoLocation.latitude'}) ],
},
    
	},
	
					
	longitude:{
		type: 'number',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Project.geoLocation.longitude'),
				rules: [ (value)=> (value === undefined || value === null || typeof +value === 'number') || _BaseModel.t('rules.type.number', {modelName:'Project', path:'geoLocation.longitude'}) ],
},
    
	},
	
},
			dates: 				{
				planned: 					{
						
	start:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Project.dates.planned.start'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Project', path:'dates.planned.start'}) ],
},
    
	},
	
						
	end:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Project.dates.planned.end'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Project', path:'dates.planned.end'}) ],
},
    
	},
	
},
				actual: 					{
						
	start:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Project.dates.actual.start'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Project', path:'dates.actual.start'}) ],
},
    
	},
	
						
	end:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Project.dates.actual.end'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Project', path:'dates.actual.end'}) ],
},
    
	},
	
},
},
			address: 				{
					
	street:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Project.address.street'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Project', path:'address.street'}) ],
},
    
	},
	
					
	zipCode:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Project.address.zipCode'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Project', path:'address.zipCode'}) ],
},
    
	},
	
					
	city:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Project.address.city'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Project', path:'address.city'}) ],
},
    
	},
	
					
	country:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Project.address.country'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Project', path:'address.country'}) ],
},
    
	},
	
},
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Project._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, general={}, projectId='', geoLocation={}, dates={}, address={}, _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.general=GeneralClass.create(general);
		this.projectId=projectId;
		this.geoLocation=GeoLocationClass.create(geoLocation);
		this.dates=DatesClass.create(dates);
		this.address=AddressClass.create(address);
		this._id=_id;
	}

	static create(data) {
		return new Project(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Project || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Project.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Project ? item : Project.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({type=undefined, category=undefined, customer=undefined, projectContacts=[], responsibleWorkers=[], status=undefined, workRecords=[], projectTimeReports=[], }={}){
		this.type= (type instanceof ProjectType || typeof type === 'string' || !type) ? type : ProjectType.create(type);
		this.category= (category instanceof ProjectCategory || typeof category === 'string' || !category) ? category : ProjectCategory.create(category);
		this.customer= (customer instanceof Customer || typeof customer === 'string' || !customer) ? customer : Customer.create(customer);
		if(Array.isArray(projectContacts)){
			this.projectContacts=[];
			for(const item of projectContacts){
				if(typeof item === 'string') this.projectContacts.push(item)
				else if(typeof item === 'object')
					this.projectContacts.push(item instanceof Person ? item : Person.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.projectContacts=projectContacts;
		}
		if(Array.isArray(responsibleWorkers)){
			this.responsibleWorkers=[];
			for(const item of responsibleWorkers){
				if(typeof item === 'string') this.responsibleWorkers.push(item)
				else if(typeof item === 'object')
					this.responsibleWorkers.push(item instanceof Worker ? item : Worker.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.responsibleWorkers=responsibleWorkers;
		}
		this.status= (status instanceof ProjectStatus || typeof status === 'string' || !status) ? status : ProjectStatus.create(status);
		if(Array.isArray(workRecords)){
			this.workRecords=[];
			for(const item of workRecords){
				if(typeof item === 'object')
					this.workRecords.push(item instanceof WorkRecord ? item : WorkRecord.create(item))
				else this.workRecords.push(item)
			}
		} else {
			this.workRecords=workRecords;
		}
		if(Array.isArray(projectTimeReports)){
			this.projectTimeReports=[];
			for(const item of projectTimeReports){
				if(typeof item === 'object')
					this.projectTimeReports.push(item instanceof ProjectTimeReport ? item : ProjectTimeReport.create(item))
				else this.projectTimeReports.push(item)
			}
		} else {
			this.projectTimeReports=projectTimeReports;
		}
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class GeneralClass {
	constructor({name='', description='', }={}){
		this.name=name;
		this.description=description;
	}

	static create(data) {
		return new GeneralClass(data);
	}
}

class GeoLocationClass {
	constructor({latitude='', longitude='', }={}){
		this.latitude=latitude;
		this.longitude=longitude;
	}

	static create(data) {
		return new GeoLocationClass(data);
	}
}

class DatesClass {
	constructor({planned={}, actual={}, }={}){
		this.planned=PlannedClass.create(planned);
		this.actual=ActualClass.create(actual);
	}

	static create(data) {
		return new DatesClass(data);
	}
}

class PlannedClass {
	constructor({start=undefined, end=undefined, }={}){
		this.start=start;
		this.end=end;
	}

	static create(data) {
		return new PlannedClass(data);
	}
}

class ActualClass {
	constructor({start=undefined, end=undefined, }={}){
		this.start=start;
		this.end=end;
	}

	static create(data) {
		return new ActualClass(data);
	}
}

class AddressClass {
	constructor({street='', zipCode='', city='', country='', }={}){
		this.street=street;
		this.zipCode=zipCode;
		this.city=city;
		this.country=country;
	}

	static create(data) {
		return new AddressClass(data);
	}
}
